import { jsx } from "react/jsx-runtime";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { validateTidalLicense } from "../../base/index.js";
function AddTask(props) {
  return /* @__PURE__ */ jsx(
    AddTaskIcon,
    {
      "data-testid": "AddTask",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AddTask",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
AddTask.tidalIconMeta = {
  categories: "miscellaneous",
  name: "AddTask"
};
validateTidalLicense();
export {
  AddTask
};
//# sourceMappingURL=AddTask.js.map
